export const setSourceTestConnectionResult = 'setSourceTestConnectionResult';
